// Form statuses come back either as the stored key ("needs_review") or as the
// label the API prints for it ("Needs Review"), so everything here keys off a
// slug of whatever arrived.
export const formStatusKey = (status) =>
  `${status === null || status === undefined ? "" : status}`
    .trim()
    .toLowerCase()
    .replace(/[\s-]+/g, "_");

// Tones are the app's own variants, the same set DVIR's status badge uses:
// green for done, blue for in flight, amber for waiting on somebody, red for
// not accepted, and the neutral chip for anything not started yet.
const STATUS_TONES = {
  published: "success",
  approved: "success",
  completed: "success",
  in_progress: "primary",
  needs_review: "warning",
  // Sent back and refused are both "not accepted"; the label says which.
  changes_requested: "danger",
  denied: "danger",
};

export const formStatusTone = (status) => STATUS_TONES[formStatusKey(status)] || "secondary";

export const isPublished = (status) => formStatusKey(status) === "published";
